module.exports = __webpack_public_path__ + "catalog/items/office/Desk/Desk.svg";